<template>
  <AddBannerImage />
</template>

<script>
import AddBannerImage from '@/components/AddBannerImage.vue';

// @ is an alias to /src


export default {
  name: "AddBannerImageView",
  components: {
    AddBannerImage,
  },
};
</script>
